import { createRoute, redirect } from '@tanstack/react-router';
import { bareAuthedRoute, loadSession, publicLayoutRoute } from '../../router/parents';
import { LandingPage } from '../landing';
import { OnboardingPage } from './onboarding';
import { ForgotPasswordPage, InvitePage, PricingPage, ResetPasswordPage, SignInPage, SignUpPage, VerifyEmailPage } from './pages';

const str = (v: unknown) => (typeof v === 'string' ? v : undefined);

export const authRoutes = [
  // Public landing page; signed-in visitors go straight to their dashboard.
  createRoute({
    getParentRoute: () => publicLayoutRoute,
    path: '/',
    beforeLoad: async ({ context }) => {
      if (await loadSession(context.queryClient)) throw redirect({ to: '/dashboard' });
    },
    component: LandingPage,
  }),
  createRoute({ getParentRoute: () => publicLayoutRoute, path: '/pricing', component: PricingPage }),
  createRoute({ getParentRoute: () => publicLayoutRoute, path: '/sign-in', component: SignInPage, validateSearch: (s: Record<string, unknown>): { redirect?: string } => ({ redirect: str(s.redirect) }) }),
  createRoute({ getParentRoute: () => publicLayoutRoute, path: '/sign-up', component: SignUpPage, validateSearch: (s: Record<string, unknown>): { plan?: string } => ({ plan: str(s.plan) }) }),
  createRoute({ getParentRoute: () => publicLayoutRoute, path: '/verify-email', component: VerifyEmailPage, validateSearch: (s: Record<string, unknown>): { token?: string; next?: string } => ({ token: str(s.token), next: str(s.next) }) }),
  createRoute({ getParentRoute: () => publicLayoutRoute, path: '/invite', component: InvitePage, validateSearch: (s: Record<string, unknown>): { token?: string } => ({ token: str(s.token) }) }),
  createRoute({ getParentRoute: () => publicLayoutRoute, path: '/forgot-password', component: ForgotPasswordPage }),
  createRoute({ getParentRoute: () => publicLayoutRoute, path: '/reset-password', component: ResetPasswordPage, validateSearch: (s: Record<string, unknown>): { token?: string; error?: string } => ({ token: str(s.token), error: str(s.error) }) }),
] as const;

export const onboardingRoutes = [createRoute({ getParentRoute: () => bareAuthedRoute, path: '/onboarding', component: OnboardingPage })] as const;
